// Add your custom JS here.
const Cookies = require('./js-cookie');
const bootstrap = require('./bootstrap.js');

function uet_contact_report_conversion() {
    window.uetq = window.uetq || [];
    window.uetq.push('event', 'contact',
    {"event_category":"submit"});
};
function uet_policy_report_conversion() {
    window.uetq = window.uetq || [];
    window.uetq.push('event', 'policy',
    {"event_category":"submit"});
};

function uet_form_report_conversion() {
    window.uetq = window.uetq || [];
    window.uetq.push('event', 'form',
    {"event_category":"submit"});
}

jQuery(document).ready(function ($) {
    $('#step-1').click(function() {
        uet_contact_report_conversion();
    });

    $('#step-2').click(function() {
        uet_policy_report_conversion();
    });

    $('#step-4').click(function() {
        uet_form_report_conversion();
    });

    //Parse URL
    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        let regex = new RegExp("[\\?&;]" + name + "=([^&;#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    // Give the URL parameters variable names
    let utmSource = getParameterByName('utm_source');
    let utmMedium = getParameterByName('utm_medium');
    let utmContent = getParameterByName('utm_content');
    let utmTerm = getParameterByName('utm_term');
    let utmCampaign = getParameterByName('utm_campaign');
    let utmMatchType = getParameterByName('matchtype');
    let googleClickId = getParameterByName('gclid');
    let facebookClickId = getParameterByName('fbclid');
    let microsoftClickId = getParameterByName('msclkid');
    let campaignID= getParameterByName('campaign_id');

    //set cookies when utm parameters exist
    let field = 'utm_source';
    let url = window.location.href;
    if (url.indexOf('?' + field + '=') != -1 || url.indexOf('&' + field + '=') != -1) {
        Cookies.set('utm_source', utmSource, {expires: 30});
        Cookies.set('utm_medium', utmMedium, {expires: 30});
        Cookies.set('utm_content', utmContent, {expires: 30});
        Cookies.set('utm_term', utmTerm, {expires: 30});
        Cookies.set('utm_campaign', utmCampaign, {expires: 30});
        Cookies.set('utm_matchtype', utmMatchType, {expires: 30});
    }

    // Set click Ids
    if (googleClickId !== '') {
        Cookies.set('googleClickId', googleClickId, {expires: 30});
    }
    if (facebookClickId !== '') {
        Cookies.set('facebookClickId', facebookClickId, {expires: 30});
    }
    if (microsoftClickId !== '') {
        Cookies.set('microsoftClickId', microsoftClickId, {expires: 30});
    }

    if (campaignID !== '') {
        Cookies.set('campaign_id', campaignID, {expires: 30});
    }

    let pathname = window.location.pathname.replace(/\//g, '').replace('selleasy', '').toLowerCase();

    let ipHttp = new XMLHttpRequest();
    ipHttp.open('GET', 'https://api.ipify.org', true);
    ipHttp.send(null);
    ipHttp.onreadystatechange = function () {
        if (ipHttp.readyState == 4 && ipHttp.status == 200) {
            if (ipHttp.readyState == 4 && ipHttp.status == 200) {
                Cookies.set('ip_address', ipHttp.responseText, {expires: 30});
            }
        }
    }

    if ( pathname === 'get-started' ) {
        document.getElementById('utm_source').value = Cookies.get('utm_source');
        document.getElementById('utm_medium').value = Cookies.get('utm_medium');
        document.getElementById('utm_campaign').value = Cookies.get('utm_campaign');
        document.getElementById('utm_term').value = Cookies.get('utm_term');
        document.getElementById('utm_content').value = Cookies.get('utm_content');
        document.getElementById('utm_matchtype').value = Cookies.get('utm_matchtype');
        document.getElementById('googleClickId').value = Cookies.get('googleClickId');
        document.getElementById('facebookClickId').value = Cookies.get('facebookClickId');
        document.getElementById('microsoftClickId').value = Cookies.get('microsoftClickId');
        document.getElementById('campaign_id').value = Cookies.get('campaign_id');
        if( ipHttp.responseText !== '' ) {
            document.getElementById('ip_address').value = Cookies.get('ip_address');
        } else {
            ipHttp.open('GET', 'https://api.ipify.org', true);
            ipHttp.send(null);
            ipHttp.onreadystatechange = function () {
                if (ipHttp.readyState == 4 && ipHttp.status == 200) {
                    if (ipHttp.readyState == 4 && ipHttp.status == 200) {
                        document.getElementById('ip_address').value = ipHttp.responseText;
                    }
                }
            }
        }
    }

    const phone1 = document.getElementById('phone_number');
    const phone2 = document.getElementById('not_insured_phone');
    const phone3 = document.getElementById('second_insured_phone_number');

    let phoneMask;
    if (typeof(phone1) != 'undefined' && phone1 != null) {
        phoneMask = IMask(phone1, {
            mask: '(#00) 000-0000',
            definitions: {'#': /^[023-9]{1}$/}
        });
    }
    if (typeof(phone2) != 'undefined' && phone2 != null) {
        phoneMask = IMask(phone2, {
            mask: '(#00) 000-0000',
            definitions: {'#': /^[023-9]{1}$/}
        });
    }

    if (typeof(phone3) != 'undefined' && phone3 != null) {
        phoneMask = IMask(phone3, {
            mask: '(#00) 000-0000',
            definitions: {'#': /^[023-9]{1}$/}
        });
    }

    let prevAge = getParameterByName('age') || "";
    $('#age-bt').text('birthdate?');

    if(prevAge.length > 0) {
        $('#switch_to_age').prop('checked', true);
        $('#age').val(prevAge);
        $('#birthdate_container').css('display', 'none');
        $('#age-bt').text('age?');
        $('#age_container').css('display', 'flex');
        $('#birth_month').val('');
        $('#birth_day').val('');
        $('#birth_year').val('');
        $('#birth_month-error').remove();
        $('#birth_day-error').remove();
        $('#birth_year-error').remove();
        $('#age-error-node').remove();
    }

    $('#switch_to_age').change(function() {
        if($(this).is(':checked')) {
            $('#age').val(prevAge);
            $('#birthdate_container').css('display', 'none');
            $('#age-bt').text('age?');
            $('#age_container').css('display', 'flex');
            $('#birth_month').val('');
            $('#birth_day').val('');
            $('#birth_year').val('');
            $('#birth_month-error').remove();
            $('#birth_day-error').remove();
            $('#birth_year-error').remove();
            $('#age-error-node').remove();
        } else {
            $('#age_container').css('display', 'none');
            $('#age-bt').text('birthdate?');
            $('#birthdate_container').css('display', 'flex');
            $('#age').val(prevAge);
            $('#age-error-node').remove();
        }
    });

    $('#not-insured-age-bt').text('birthdate?');
    $('#not_insured_switch_to_age').change(function() {
        if($(this).is(':checked')) {
            $('#not_insured_age').val('');
            $('#not_insured_birthdate_container').css('display', 'none');
            $('#not-insured-age-bt').text('age?');
            $('#not_insured_age_container').css('display', 'flex');
            $('#not_insured_birth_month').val('');
            $('#not_insured_birth_day').val('');
            $('#not_insured_birth_year').val('');
            $('#not_insured_birth_month-error').remove();
            $('#not_insured_birth_day-error').remove();
            $('#not_insured_birth_year-error').remove();
            $('#age-error-node').remove();
        } else {
            $('#not_insured_age_container').css('display', 'none');
            $('#not-insured-age-bt').text('birthdate?');
            $('#not_insured_birthdate_container').css('display', 'flex');
            $('#not_insured_age').val('');
            $('#age-error-node').remove();
        }
    });

    $('#second-insured-age-bt').text('birthdate?');
    $('#second_insured_switch_to_age').change(function() {
        if($(this).is(':checked')) {
            $('#second_insured_age').val('');
            $('#second_insured_birthdate_container').css('display', 'none');
            $('#second-insured-age-bt').text('age?');
            $('#second_insured_age_container').css('display', 'flex');
            $('#second_insured_birth_month').val('');
            $('#second_insured_birth_day').val('');
            $('#second_insured_birth_year').val('');
            $('#second_insured_birth_month-error').remove();
            $('#second_insured_birth_day-error').remove();
            $('#second_insured_birth_year-error').remove();
            $('#second_insured_age-error-node').remove();
        } else {
            $('#second_insured_age_container').css('display', 'none');
            $('#second-insured-age-bt').text('birthdate?');
            $('#second_insured_birthdate_container').css('display', 'flex');
            $('#second_insured_age').val('');
            $('#age-error-node').remove();
        }
    });


    $('#hear_about_ovid').change(function() {
        let current_value = $(this).val();
        if(current_value == 'Web - TV') {
            $('.tv-dropdown').addClass('activated');
            $('.internet-dropdown').removeClass('activated');
        } else if(current_value == 'Web - Internet/Social Media') {
            $('.internet-dropdown').addClass('activated');
            $('.tv-dropdown').removeClass('activated');
        } else {
            $('.tv-dropdown').removeClass('activated');
            $('.internet-dropdown').removeClass('activated');
            $('select[name="stated_source_campaign"]').val('');
        }
    });

    /* Benefits */
    const currency = document.getElementById('benefits');
    if (currency) {
        IMask(currency, {
            mask: [
                {
                    mask: '$num{.}`cents',
                    blocks: {
                        num: {
                            mask: Number,
                            signed: true,
                            scale: 0,
                            thousandsSeparator: ',',
                            padFractionalZeros: true,
                            radix: '.'
                        },
                        cents: {
                            mask: '`0`0',
                            normalizeZeros: true,
                            padFractionalZeros: true,
                        }
                    },
                    overwrite: true
                }
            ]
        });
        $.validator.addMethod("benefitValidation", function (value, element) {
            return this.optional(element) || benefitControl(value);
        }, "{0}");
        const benefitControl = (value) => {
            let benefit = parseInt(value.replace(/[$,]+/g, ''), 10);
            if (benefit < 10000 || benefit > 99999999) {
                const responseMsg = benefit < 10000 ?
                    'This policy is very low, please verify the amount.' :
                    'This policy is very large, please verify the amount. If accurate, please call us.';
                $.validator.messages.benefitValidation = responseMsg;
                return false;
            }
            return true;
        }
        $('#benefits').blur(function (event) {
            if (event.keyCode == 8 || event.keyCode == 46) {
                return;
            }
            if ($(this).val() !== '') {
                let benefit = parseInt($(this).val().replace(/[$,]+/g, ''), 10);
                if(Number.isNaN(benefit)) benefit = 0;
                let separatedValue = benefit.toLocaleString('en-US');
                let newValue = '$' + separatedValue;
                $(this).val(newValue);
            }
        });
    };


    /* Benefits2 */
    const currency2 = document.getElementById('benefits2');
    if (currency2) {
        IMask(currency2, {
            mask: [
                {
                    mask: '$num{.}`cents',
                    blocks: {
                        num: {
                            mask: Number,
                            signed: true,
                            scale: 0,
                            thousandsSeparator: ',',
                            padFractionalZeros: true,
                            radix: '.'
                        },
                        cents: {
                            mask: '`0`0',
                            normalizeZeros: true,
                            padFractionalZeros: true,
                        }
                    },
                    overwrite: true
                }
            ]
        });
        $.validator.addMethod("benefit2Validation", function (value, element) {
            return this.optional(element) || benefit2Control(value);
        }, "{0}");
        const benefit2Control = (value) => {
            let benefit2 = parseInt(value.replace(/[$,]+/g, ''), 10);
            if (benefit2 < 10000 || benefit2 > 99999999) {
                const responseMsg2 = benefit2 < 10000 ?
                    'This policy is very low, please verify the amount.' :
                    'This policy is very large, please verify the amount. If accurate, please call us.';
                $.validator.messages.benefit2Validation = responseMsg2;
                return false;
            }
            return true;
        }
        $('#benefits2').blur(function (event) {
            if (event.keyCode == 8 || event.keyCode == 46) {
                return;
            }
            if ($(this).val() !== '') {
                let benefit2 = parseInt($(this).val().replace(/[$,]+/g, ''), 10);
                if(Number.isNaN(benefit2)) benefit2 = 0;
                let separatedValue2 = benefit2.toLocaleString('en-US');
                let newValue2 = '$' + separatedValue2;
                $(this).val(newValue2);
            }
        });
    };

    $.validator.addMethod("invalidCharacter", function(value, element) {
        return this.optional( element ) || !/[^A-Za-z\'\-\s]/gi.test( value );
    }, "Invalid characters. Please use only A-Z, ' or -.");


    $.validator.addMethod("phoneUS", function(phone_number, element) {
        return this.optional(element) || phone_number.length > 9 &&
            phone_number !== '(888) 888-8888';
    }, "Please enter a valid phone number");

    let year = new Date().getFullYear(),
        low = year - 129,
        high = year - 18;

    $("#ovid-form").validate({
        onfocusout: function (element) {
            this.element(element);
        },
        rules : {
            first_name : { invalidCharacter : true },
            second_insured_first_name : { invalidCharacter : true },
            not_insured_first_name : { invalidCharacter : true },
            last_name : { invalidCharacter : true },
            second_insured_last_name : { invalidCharacter : true },
            not_insured_last_name : { invalidCharacter : true },
            benefits: { benefitValidation: true },
            benefits2: { benefit2Validation: true },
            phone_number: {
                minlength: 14,
                maxlength : 14,
                phoneUS: true
            },
            not_insured_phone : {
                minlength: 14,
                maxlength : 14,
                phoneUS: true
            },
            second_insured_phone_number : {
                minlength: 14,
                maxlength : 14,
                phoneUS: true
            },
            birth_day: {
                number: true,
                range: [1, 31]
            },
            birth_month: {
                number: true,
                range: [1, 12]
            },
            birth_year: {
                number: true,
                range: [low, high]
            },
            not_insured_birth_day: {
                number: true,
                range: [1, 31]
            },
            not_insured_birth_month: {
                number: true,
                range: [1, 12]
            },
            not_insured_birth_year: {
                number: true,
                range: [low, high]
            },
            second_insured_birth_day: {
                number: true,
                range: [1, 31]
            },
            second_insured_birth_month: {
                number: true,
                range: [1, 12]
            },
            second_insured_birth_year: {
                number: true,
                range: [low, high]
            },
        }
    });

    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    $('#step-1').on('click', function() {
        if( $( "#ovid-form" ).valid() ) {
            if(document.getElementById('phone-error-node')) {
                return;
            }
            if(document.getElementById('email-error-node')) {
                return;
            }
            let id = $('#entry_id').val();
            let data1 = [
                $('input[name="first_name"]').val(),
                $('input[name="last_name"]').val(),
                $('input[name="phone_number"]').val(),
                $('input[name="email_address"]').val(),
                $('input[name="insured_radio"]:checked').val(),
                $('input[name="terms"]').val(),
                $('input[name="utm_source"]').val(),
                $('input[name="utm_medium"]').val(),
                $('input[name="utm_campaign"]').val(),
                $('input[name="utm_term"]').val(),
                $('input[name="utm_content"]').val(),
                $('input[name="ip_address"]').val(),
                $('input[name="cov_gaid"]').val(),
                $('input[name="twilio_validate"]').val(),
                $('input[name="google_click_id"]').val(),
                $('input[name="facebook_click_id"]').val(),
                $('input[name="microsoft_click_id"]').val(),
                $('input[name="google_recaptcha"]').val(),
                $('input[name="unique_identifier"]').val(),
                $('input[name="google_reasons"]').val(),
                $('input[name="campaign_id"]').val(),
                $('input[name="sms_consent"]:checked').val()
            ];
            partialSave(data1, 'one', id);
            formStepsNum++;
            updateFormSteps('nextBtns');
        }
    });

    $('#step-2').on('click', function() {
        if( $( "#ovid-form" ).valid() ) {
            if($('#insured_false').is(':checked')) {
                $('#not-insured-relationship, #not-insured-name, #not-insured-contact, #not-insured-birthdate, #not-insured-sex, #not-insured-health').css('display', 'flex');
                $('#insured-birthdate, #insured-sex, #insured-health').css('display', 'none');
                $('.form-sidebar').addClass('expanded');
            }
            if($('#insured_true').is(':checked')) {
                $('#insured-birthdate, #insured-sex, #insured-health').css('display', 'flex');
                $('#not-insured-relationship, #not-insured-name, #not-insured-contact, #not-insured-birthdate, #not-insured-sex, #not-insured-health').css('display', 'none');
                $('.form-sidebar').removeClass('expanded');
            }
            if(document.getElementById('benefit-error-node')) {
                return;
            }
            let id = $('#entry_id').val();
            let data2 = [
                $('input[name="benefits"]').val(),
                $('select[name="policy_type"]').val(),
                $('select[name="policy_time"]').val(),
                $('input[name="former_employer1"]:checked').val()
            ];

            if ($('#additional-policy').is(':visible') ) {
                data2.push($('input[name="benefits2"]').val());
                data2.push($('select[name="policy_type2"]').val());
                data2.push($('select[name="policy_time2"]').val());
                data2.push($('input[name="former_employer3"]:checked').val());
            }
            partialSave(data2, 'two', id);
            formStepsNum++;
            updateFormSteps('nextBtns');
        }
    });

    $('#step-3').on('click', function() {
        if($('#insured_true').is(':checked')) {
            let name = $('#first_name').val() + ' ' + $('#last_name').val();
            $('#primary-contact').text(name);
        }
        if($('#insured_false').is(':checked')) {
            let name = $('#not_insured_first_name').val() + ' ' + $('#not_insured_last_name').val();
            $('#primary-contact').text(name);
        }
        if($('#second_insured_first_name').val().length != 0) {
            let name2 = $('#second_insured_first_name').val() + ' ' + $('#second_insured_last_name').val();
            $('#secondary-contact').text(name2);
            $('#another-health-information-text').text(name2);
            $('#another-health-information').css('display', 'inline');
        }
        if($('#second_insured_first_name').val().length == 0) {
            $('#another-health-information').css('display', 'none');
        }
        if( $( "#ovid-form" ).valid() ) {
            if(document.getElementById('age-error-node')) {
                return;
            }
            if(document.getElementById('email-error-node')) {
                return;
            }
            $('.form-sidebar').removeClass('expanded');

            let stated = Cookies.get('campaign_id');
            if(stated) {
                $('#step-4').replaceWith('<button id="custom-btn-submit" class="btn-next btn btn-primary" type="submit" name="submit" onclick="addLoader()">Submit</button>');
                $('#medicalSupport1').removeClass('required');
                $('#medicalSupport2').removeClass('required');
                $('#medicalSupport3').removeClass('required');
                $('#medicalSupport4').removeClass('required');
                $('#medicalSupport4').removeClass('required');
                $('#healthHistory1').removeClass('required');
                $('#healthHistory2').removeClass('required');
                $('#healthHistory3').removeClass('required');
                $('#healthHistory4').removeClass('required');
            }

            let id = $('#entry_id').val();
            let data3 = [
                $('input[name="birth_day"]').val(),
                $('input[name="birth_month"]').val(),
                $('input[name="birth_year"]').val(),
                $('input[name="age"]').val(),
                $('input[name="gender"]:checked').val(),
                $('input[name="current_health"]:checked').val()
            ];

            data3.push($('input[name="not_insured_first_name"]').val());
            data3.push($('input[name="not_insured_last_name"]').val());
            data3.push($('input[name="not_insured_phone"]').val());
            data3.push($('input[name="not_insured_email"]').val());
            data3.push($('input[name="not_insured_birth_day"]').val());
            data3.push($('input[name="not_insured_birth_month"]').val());
            data3.push($('input[name="not_insured_birth_year"]').val());
            data3.push($('input[name="not_insured_age"]').val());
            data3.push($('input[name="not_insured_gender"]:checked').val());
            data3.push($('input[name="not_insured_current_health"]:checked').val());
            data3.push($('#not_insured_relationship').val());
            data3.push($('input[name="second_insured_deceased"]:checked').val());
            data3.push($('input[name="second_insured_first_name"]').val());
            data3.push($('input[name="second_insured_last_name"]').val());
            data3.push($('input[name="second_insured_phone_number"]').val());
            data3.push($('input[name="second_insured_email_address"]').val());
            data3.push($('input[name="second_insured_birth_day"]').val());
            data3.push($('input[name="second_insured_birth_month"]').val());
            data3.push($('input[name="second_insured_birth_year"]').val());
            data3.push($('input[name="second_insured_age"]').val());
            data3.push($('input[name="second_insured_gender"]:checked').val());
            data3.push($('input[name="second_insured_health"]:checked').val());
            data3.push($('#relationship').val());
 
            partialSave(data3, 'three', id);
            formStepsNum++;
            updateFormSteps('nextBtns');
        }
    });

    $('#step-4').on('click', function() {
        if( $( "#ovid-form" ).valid() ) {
            formStepsNum++;
            updateFormSteps('nextBtns');
        }
    });

    $('#step-5').on('click', function() {
        if( $( "#ovid-form" ).valid() ) {
            let loader = '<div id="ovid-loader" style="width:100%;height:100%;position:fixed;top:0;left:0;background-color:rgba(255,255,255,0.75);z-index:999;display:flex; flex-direction:column; justify-content:center; align-items:center;"><img src="/wp-content/uploads/2023/03/7851.gif" alt="loader"><p>Processing...</p></div>'
            $('#ovid-form').append(loader);
        }
    });

    const prevBtns = document.querySelectorAll(".btn-prev");
    const formSteps = document.querySelectorAll(".form-step");
    const progressStep = document.querySelectorAll(".progress-step");
    let formStepsNum = 0;

    if (window.location.pathname === '/get-started/') {
        let url = new URL(window.location);
        url.searchParams.set('formStage', 1);
        history.pushState({}, '', url);
    }

    prevBtns.forEach(btn => {
        btn.addEventListener("click", () => {
            formStepsNum--;
            updateFormSteps('prevBtns');
        });
    });

    function updateFormSteps(btns) {
        if (btns === 'nextBtns') {
            formSteps[formStepsNum - 1].classList.remove("form-step-active");
            progressStep[formStepsNum - 1].classList.remove("progress-step-active");
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        } else {
            formSteps[formStepsNum + 1].classList.remove("form-step-active");
            progressStep[formStepsNum + 1].classList.remove("progress-step-active");
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }

        if (window.location.pathname === '/get-started/') {
            let url = new URL(window.location);
            url.searchParams.set('formStage', formStepsNum + 1);
            history.pushState({}, '', url);
        }

        formSteps[formStepsNum].classList.add("form-step-active");

        if (formStepsNum < 4) {
            progressStep[formStepsNum].classList.add("progress-step-active");
        }
    }

    setTimeout(function() {
        let cov_GAID = readCookie('_ga');
        if(document.getElementById('cov_gaid')) {
            document.getElementById('cov_gaid').value = cov_GAID;
        }
    }, 500);

    function readCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) > -1) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    let calculateAge = (self, year, month = 0, day, from = null) => {
        let today = new Date(),
            monthCeroIndex = parseInt(month) - 1,
            dob = new Date(year, monthCeroIndex, day),
            diffInMs = today - dob.getTime(),
            ageDate = new Date(diffInMs),
            age = Math.abs(ageDate.getUTCFullYear() - 1970);

        if(from == 'not_insured') {
            $('#not_insured_age').val(age);
        } else if(from == 'second_insured') {
            $('#second_insured_age').val(age);
        } else {
            $('#age').val(age);
        }
        checkDateValue(self, age);
    };

    let newErrorNode = (ageLimit) => {
        let spa = document.createElement('span');
        spa.innerHTML = ageLimit === 'older' ? 'Please verify that you are less than 130 years old.' : 'Please verify that you are at least 18 old.';
        spa.classList.add('error');
        spa.setAttribute('id', 'age-error-node');
        spa.style.color = '#c2272d';
        spa.style.fontSize = '12px';
        spa.style.display = 'block';
        spa.style.paddingTop = '4px';
        return spa;
    }

    let checkDateValue = (self, age, stringModifier = null) => {
        if (stringModifier && stringModifier == 'age' && age == '') {
            return;
        }
        if (age > 129 ) {
            if ($('#age-error-node').length == 0) {
                let newError = newErrorNode('older');
                self.addClass('error').parent().parent().after(newError);
            }

        } else if(age < 18) {
            if ($('#age-error-node').length == 0) {
                let newError = newErrorNode('younger');
                self.addClass('error').parent().parent().after(newError);
            }

        } else {
            self.removeClass('error');
            $('#age-error-node').remove();
        }
    };

    $('#age, #not_insured_age, #second_insured_age').focusout(function() {
        let self = $(this),
            age = self.val();

        checkDateValue(self, age, 'age');
    });

    $('#birth_year').focusout(function() {
        let self = $(this),
            year = self.val(),
            month = $('#birth_month').val(),
            day = $('#birth_day').val();

        calculateAge(self, year, month, day);
    });

    $('#not_insured_birth_year').focusout(function() {
        let self = $(this),
            year = self.val(),
            month = $('#not_insured_birth_month').val(),
            day = $('#not_insured_birth_day').val();

        calculateAge(self, year, month, day, 'not_insured');
    });

    $('#second_insured_birth_year').focusout(function() {
        let self = $(this),
            year = self.val(),
            month = $('#second_insured_birth_month').val(),
            day = $('#second_insured_birth_day').val();

        calculateAge(self, year, month, day, 'second_insured');
    });

    function cleanNewPolicy() {
        $('#benefits2').val('');
        $('#policy_type2').val('');
        $('#policy_time2').val('');
        $('#former_employer3').prop('checked', false);
        $('#former_employer4').prop('checked', false);
    }

    $('#another-policy').click(function () {
        $('#additional-policy').css('display', 'block');
        $(this).css('display', 'none');
        $('#remove-policy').css('display', 'block');
        $('.form-sidebar').addClass('expanded');
    });

    $('#remove-policy').click(function () {
        $('#additional-policy').css('display', 'none');
        $(this).css('display', 'none');
        $('#another-policy').css('display', 'block');
        $('.form-sidebar').removeClass('expanded');
        cleanNewPolicy();
    });

    function cleanNewInsured(deceased = false) {
        if(!deceased) {
            $('#deceased1').prop('checked', false);
            $('#deceased2').prop('checked', false);
            $('#relationship').val('');
        }
        $('#second_insured_first_name').val('');
        $('#second_insured_last_name').val('');
        $('#second_insured_phone_number').val('');
        $('#second_insured_email_address').val('');
        $('#second_insured_birth_month').val('');
        $('#second_insured_birth_day').val('');
        $('#second_insured_birth_year').val('');
        $('#second_insured_age').val('');
        $('#second_insured_gender').prop('checked', false);
        $('#second_insured_gender2').prop('checked', false);
        $('#otherHealth1').prop('checked', false);
        $('#otherHealth2').prop('checked', false);
        $('#otherHealth3').prop('checked', false);
        $('#otherHealth4').prop('checked', false);
        $('#otherHealth5').prop('checked', false);
    }

    $('#another-insured').click(function () {
        $('#additional-insured').css('display', 'block');
        $(this).css('display', 'none');
        $('#remove-insured').css('display', 'block');
        $('.form-sidebar').addClass('expanded');
    });

    $('#remove-insured').click(function () {
        $('#additional-insured').css('display', 'none');
        $(this).css('display', 'none');
        $('#another-insured').css('display', 'block');
        $('.form-sidebar').removeClass('expanded');
        cleanNewInsured();
    });

    $('#another-health-information').click(function () {
        $('#additional-health-info').css('display', 'block');
        $(this).css('display', 'none');
        $('#remove-health-information').css('display', 'block');
        $('.form-sidebar').addClass('expanded');
    });

    $('#remove-health-information').click(function () {
        $('#additional-health-info').css('display', 'none');
        $(this).css('display', 'none');
        $('#another-health-information').css('display', 'block');
        $('.form-sidebar').removeClass('expanded');
    });

    $('#deceased1').change(function () {
        if($(this).is(':checked')) {
            $('#second-insured-name, #second-insured-contact, #second-insured-birthdate, #second-insured-sex, #second-insured-current-health').css('display', 'none');
            $('.form-sidebar').addClass('expanded');
            cleanNewInsured(true);
        }
    });

    $('#deceased2').change(function () {
        if($(this).is(':checked')) {
            $('#second-insured-name, #second-insured-contact, #second-insured-birthdate, #second-insured-sex, #second-insured-current-health').css('display', 'flex');
            $('.form-sidebar').addClass('expanded');
        }
    });

    $('.form-switch .form-check-input:not(.switch_to_age)').on('change', function(e) {
        let notModal= [
            'acid_reflux',
            'als',
            'alzheimer',
            'acid_reflux2',
            'als2',
            'alzheimer2',
        ];
        if(notModal.includes(e.target.id)) {
            return;
        }
        if(e.target.checked) {
            let modalTarget = e.target.getAttribute('data-target'),
                modalInstance = new bootstrap.Modal($(modalTarget));
            modalInstance.show();
        } else {
            let itemLabel = '#' + e.target.id + 'Label',
                jqueryLabel = $(itemLabel);
            if (jqueryLabel.siblings('a').length != 0) {
                jqueryLabel.siblings('a').remove();
            }
        }
    });

    function createEditNode(nodeName) {
        let edit = document.createElement('a'),
            modalTarget = '#' + nodeName + 'Modal';
        edit.innerHTML = 'Edit';
        edit.style.color = '#d90429';
        edit.style.fontSize = '16px';
        edit.style.fontWeight = 'bold';
        edit.style.paddingLeft = '10px';
        edit.style.textDecoration = 'none';
        edit.href = modalTarget;
        edit.classList.add('edit');
        edit.setAttribute('data-bs-toggle', 'modal');
        return edit;
    }

    $('#modal-cancer-done').on('click', function() {
        let edit = createEditNode('cancer'),
            cancerLabel = $('#cancerLabel');
        if (cancerLabel.siblings('a').length == 0) {
            cancerLabel.after(edit);
        }

        // Move focus back to the associated checkbox
        setTimeout(() => {
            $('#cancer').focus();
        }, 10);
    });

    $('#modal-cancer-cancel').on('click', function() {
        $('#cancer').prop('checked', false);
        let cancerLabel = $('#cancerLabel');
        if (cancerLabel.siblings('a').length != 0) {
            cancerLabel.siblings('a').remove();
        }
    });

    $('#modal-lung-done').on('click', function() {
        let edit = createEditNode('lung'),
            lungLabel = $('#lungLabel');
        if (lungLabel.siblings('a').length == 0) {
            lungLabel.after(edit);
        }

        setTimeout(() => {
            $('#lung').focus();
        }, 10);
    });

    $('#modal-lung-cancel').on('click', function() {
        $('#lung').prop('checked', false);
        let lungLabel = $('#lungLabel');
        if (lungLabel.siblings('a').length != 0) {
            lungLabel.siblings('a').remove();
        }
    });

    $('#modal-heart-done').on('click', function() {
        let edit = createEditNode('heart'),
            heartLabel = $('#heartLabel');
        if (heartLabel.siblings('a').length == 0) {
            heartLabel.after(edit);
        }

        setTimeout(() => {
            $('#heart').focus();
        }, 10);
    });

    $('#modal-heart-cancel').on('click', function() {
        $('#heart').prop('checked', false);
        let heartLabel = $('#heartLabel');
        if (heartLabel.siblings('a').length != 0) {
            heartLabel.siblings('a').remove();
        }
    });

    $('#modal-diabetes-done').on('click', function() {
        let edit = createEditNode('diabetes'),
            diabetesLabel = $('#diabetesLabel');
        if (diabetesLabel.siblings('a').length == 0) {
            diabetesLabel.after(edit);
        }

        setTimeout(() => {
            $('#diabetes').focus();
        }, 10);
    });

    $('#modal-diabetes-cancel').on('click', function() {
        $('#diabetes').prop('checked', false);
        let diabetesLabel = $('#diabetesLabel');
        if (diabetesLabel.siblings('a').length != 0) {
            diabetesLabel.siblings('a').remove();
        }
    });

    $('#modal-kidney-done').on('click', function() {
        let edit = createEditNode('kidney'),
            kidneyLabel = $('#kidneyLabel');
        if (kidneyLabel.siblings('a').length == 0) {
            kidneyLabel.after(edit);
        }

        setTimeout(() => {
            $('#kidney').focus();
        }, 10);
    });

    $('#modal-kidney-cancel').on('click', function() {
        $('#kidney').prop('checked', false);
        let kidneyLabel = $('#kidneyLabel');
        if (kidneyLabel.siblings('a').length != 0) {
            kidneyLabel.siblings('a').remove();
        }
    });

    $('#modal-liver-done').on('click', function() {
        let edit = createEditNode('liver'),
            liverLabel = $('#liverLabel');
        if (liverLabel.siblings('a').length == 0) {
            liverLabel.after(edit);
        }

        setTimeout(() => {
            $('#liver').focus();
        }, 10);
    });

    $('#modal-liver-cancel').on('click', function() {
        $('#liver').prop('checked', false);
        let liverLabel = $('#liverLabel');
        if (liverLabel.siblings('a').length != 0) {
            liverLabel.siblings('a').remove();
        }
    });

    $('#modal-sclerosis-done').on('click', function() {
        let edit = createEditNode('sclerosis'),
            sclerosisLabel = $('#sclerosisLabel');
        if (sclerosisLabel.siblings('a').length == 0) {
            sclerosisLabel.after(edit);
        }

        setTimeout(() => {
            $('#sclerosis').focus();
        }, 10);
    });

    $('#modal-sclerosis-cancel').on('click', function() {
        $('#sclerosis').prop('checked', false);
        let sclerosisLabel = $('#sclerosisLabel');
        if (sclerosisLabel.siblings('a').length != 0) {
            sclerosisLabel.siblings('a').remove();
        }
    });

    $('#modal-parkinson-done').on('click', function() {
        let edit = createEditNode('parkinson'),
            parkinsonLabel = $('#parkinsonLabel');
        if (parkinsonLabel.siblings('a').length == 0) {
            parkinsonLabel.after(edit);
        }

        setTimeout(() => {
            $('#parkinson').focus();
        }, 10);
    });

    $('#modal-parkinson-cancel').on('click', function() {
        $('#parkinson').prop('checked', false);
        let parkinsonLabel = $('#parkinsonLabel');
        if (parkinsonLabel.siblings('a').length != 0) {
            parkinsonLabel.siblings('a').remove();
        }
    });

    $('#modal-stroke-done').on('click', function() {
        let edit = createEditNode('stroke'),
            strokeLabel = $('#strokeLabel');
        if (strokeLabel.siblings('a').length == 0) {
            strokeLabel.after(edit);
        }

        setTimeout(() => {
            $('#stroke').focus();
        }, 10);
    });

    $('#modal-stroke-cancel').on('click', function() {
        $('#stroke').prop('checked', false);
        let strokeLabel = $('#strokeLabel');
        if (strokeLabel.siblings('a').length != 0) {
            strokeLabel.siblings('a').remove();
        }
    });

    $('#modal-cancer2-done').on('click', function() {
        let edit = createEditNode('cancer2'),
            cancer2Label = $('#cancer2Label');
        if (cancer2Label.siblings('a').length == 0) {
            cancer2Label.after(edit);
        }

        setTimeout(() => {
            $('#cancer2').focus();
        }, 10);
    });

    $('#modal-cancer2-cancel').on('click', function() {
        $('#cancer2').prop('checked', false);
        let cancer2Label = $('#cancer2Label');
        if (cancer2Label.siblings('a').length != 0) {
            cancer2Label.siblings('a').remove();
        }
    });

    $('#modal-lung2-done').on('click', function() {
        let edit = createEditNode('lung2'),
            lung2Label = $('#lung2Label');
        if (lung2Label.siblings('a').length == 0) {
            lung2Label.after(edit);
        }

        setTimeout(() => {
            $('#lung2').focus();
        }, 10);
    });

    $('#modal-lung2-cancel').on('click', function() {
        $('#lung2').prop('checked', false);
        let lung2Label = $('#lung2Label');
        if (lung2Label.siblings('a').length != 0) {
            lung2Label.siblings('a').remove();
        }
    });

    $('#modal-heart2-done').on('click', function() {
        let edit = createEditNode('heart2'),
            heart2Label = $('#heart2Label');
        if (heart2Label.siblings('a').length == 0) {
            heart2Label.after(edit);
        }

        setTimeout(() => {
            $('#heart2').focus();
        }, 10);
    });

    $('#modal-heart2-cancel').on('click', function() {
        $('#heart2').prop('checked', false);
        let heart2Label = $('#heart2Label');
        if (heart2Label.siblings('a').length != 0) {
            heart2Label.siblings('a').remove();
        }
    });

    $('#modal-diabetes2-done').on('click', function() {
        let edit = createEditNode('diabetes2'),
            diabetes2Label = $('#diabetes2Label');
        if (diabetes2Label.siblings('a').length == 0) {
            diabetes2Label.after(edit);
        }

        setTimeout(() => {
            $('#diabetes2').focus();
        }, 10);
    });

    $('#modal-diabetes2-cancel').on('click', function() {
        $('#diabetes2').prop('checked', false);
        let diabetes2Label = $('#diabetes2Label');
        if (diabetes2Label.siblings('a').length != 0) {
            diabetes2Label.siblings('a').remove();
        }
    });

    $('#modal-kidney2-done').on('click', function() {
        let edit = createEditNode('kidney2'),
            kidney2Label = $('#kidney2Label');
        if (kidney2Label.siblings('a').length == 0) {
            kidney2Label.after(edit);
        }

        setTimeout(() => {
            $('#kidney2').focus();
        }, 10);
    });

    $('#modal-kidney2-cancel').on('click', function() {
        $('#kidney2').prop('checked', false);
        let kidney2Label = $('#kidney2Label');
        if (kidney2Label.siblings('a').length != 0) {
            kidney2Label.siblings('a').remove();
        }
    });

    $('#modal-liver2-done').on('click', function() {
        let edit = createEditNode('liver2'),
            liver2Label = $('#liver2Label');
        if (liver2Label.siblings('a').length == 0) {
            liver2Label.after(edit);
        }

        setTimeout(() => {
            $('#liver2').focus();
        }, 10);
    });

    $('#modal-liver2-cancel').on('click', function() {
        $('#liver2').prop('checked', false);
        let liver2Label = $('#liver2Label');
        if (liver2Label.siblings('a').length != 0) {
            liver2Label.siblings('a').remove();
        }
    });

    $('#modal-sclerosis2-done').on('click', function() {
        let edit = createEditNode('sclerosis2'),
            sclerosis2Label = $('#sclerosis2Label');
        if (sclerosis2Label.siblings('a').length == 0) {
            sclerosis2Label.after(edit);
        }

        setTimeout(() => {
            $('#sclerosis2').focus();
        }, 10);
    });

    $('#modal-sclerosis2-cancel').on('click', function() {
        $('#sclerosis2').prop('checked', false);
        let sclerosis2Label = $('#sclerosis2Label');
        if (sclerosis2Label.siblings('a').length != 0) {
            sclerosis2Label.siblings('a').remove();
        }
    });

    $('#modal-parkinson2-done').on('click', function() {
        let edit = createEditNode('parkinson2'),
            parkinson2Label = $('#parkinson2Label');
        if (parkinson2Label.siblings('a').length == 0) {
            parkinson2Label.after(edit);
        }

        setTimeout(() => {
            $('#parkinson2').focus();
        }, 10);
    });

    $('#modal-parkinson2-cancel').on('click', function() {
        $('#parkinson2').prop('checked', false);
        let parkinson2Label = $('#parkinson2Label');
        if (parkinson2Label.siblings('a').length != 0) {
            parkinson2Label.siblings('a').remove();
        }
    });

    $('#modal-stroke2-done').on('click', function() {
        let edit = createEditNode('stroke2'),
            stroke2Label = $('#stroke2Label');
        if (stroke2Label.siblings('a').length == 0) {
            stroke2Label.after(edit);
        }

        setTimeout(() => {
            $('#stroke2').focus();
        }, 10);
    });

    $('#modal-stroke2-cancel').on('click', function() {
        $('#stroke2').prop('checked', false);
        let stroke2Label = $('#stroke2Label');
        if (stroke2Label.siblings('a').length != 0) {
            stroke2Label.siblings('a').remove();
        }
    });

    $('#healthHistory1').change(function () {
        if($(this).is(':checked')) {
            $('#healthHistoryAdditional').css('display', 'block');
        }
    });

    $('#healthHistory2').change(function () {
        if($(this).is(':checked')) {
            $('#healthHistoryAdditional').css('display', 'none');
        }
    });

    $('#healthHistory3').change(function () {
        if($(this).is(':checked')) {
            $('#healthHistoryAdditional2').css('display', 'block');
        }
    });

    $('#healthHistory4').change(function () {
        if($(this).is(':checked')) {
            $('#healthHistoryAdditional2').css('display', 'none');
        }
    });

    $('.multi-check .form-check-input.required').change(function () {
        if($(this).hasClass('valid')) {
            let elementID = '#' + $(this).attr('name') + '-error';
            $(elementID).remove();
        }
    })

    /*============================================
    Fixing bug with Android keyboards
    ==============================================*/

    let userAgent = navigator.userAgent.toLowerCase(),
        android = userAgent.indexOf("android") > -1;
    if(android) {
        $('.form-control.form-control-lg.required').click(function() {
            $('div#left-wrapper').css('margin-bottom', '30rem')
        });
    }

    /*============================================
    Navigation Functions
    ==============================================*/
    if (jQuery(window).scrollTop() === 0) {
        jQuery('#main-nav').removeClass('scrolled');
    } else {
        jQuery('#main-nav').addClass('scrolled');
    }

    jQuery(window).scroll(function () {
        if (jQuery(window).scrollTop() === 0) {
            jQuery('#main-nav').removeClass('scrolled');
        } else {
            jQuery('#main-nav').addClass('scrolled');
        }
    });

    (function () {
        jQuery('.menu-wrapper').on('click', function() {
            $('.hamburger-menu').toggleClass('animate');
        })
    })();

    /*============================================
    Partial Save and Twilio
    ==============================================*/
    let createPhoneErrorNode = () => {
        let pen = document.createElement('span');
        pen.innerHTML = 'Please enter a valid phone number.';
        pen.classList.add('error');
        pen.setAttribute('id', 'phone-error-node');
        pen.style.color = '#c2272d';
        pen.style.fontSize = '12px';
        pen.style.display = 'block';
        pen.style.paddingTop = '4px';
        return pen;
    };

    let twilioValidate = (phone) => {
        let phone_number_value = phone.val(),
            phone_number_formated = phone_number_value.replace(/[\(\)-\s]/g, '');
        if (phone_number_value.length === 14) {
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'twilio_validate',
                    phone: phone_number_formated
                },
                success: function(response) {
                    if (response) {
                        let objResponse = JSON.parse(response);
                        $('#twilio_validate').val(JSON.stringify(objResponse.caller_name));
                        if (!objResponse.caller_name || objResponse.status == 404) {
                            if(!document.getElementById('phone-error-node')) {
                                $('#phone_number-error').remove();
                                let pen = createPhoneErrorNode();
                                phone.addClass('error').after(pen);
                            }
                        } else if(objResponse.caller_name) {
                            if(document.getElementById('phone-error-node')) {
                                phone.removeClass('error');
                                $('#phone-error-node').remove();
                            }
                        }
                    }
                },
                error: function(e) {
                    if(!document.getElementById('phone-error-node')) {
                        $('#phone_number-error').remove();
                        let pen = createPhoneErrorNode();
                        phone.addClass('error').after(pen);
                    }
                }
            });
        }
    };

    $('#phone_number').change(function () {
        if($('#phone_number-error').is(':visible')) {
            $('#phone-error-node').remove();
        }
        twilioValidate($(this));
    });

    let partialSave = (data, step, id) => {
        let nonce_value = $('#ourNonce').val();
        if(step == 'one' && !$('#unique_identifier').val()) {
            const fpPromise = import('https://fpjscdn.net/v3/WyOdLwrDV5zos5Uv74bH')
                .then(FingerprintJS => FingerprintJS.load());

            fpPromise
                .then(fp => fp.get())
                .then(result => {
                    data[18] = result.visitorId;
                    $('#unique_identifier').val(result.visitorId);
                        $.ajax({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        data: {
                            action: 'partial_save',
                            data: data,
                            step: step,
                            id: id,
                            nonce: nonce_value
                        },
                        success: function(response) {
                            if(response) {
                                $('#entry_id').val(response);
                            }
                        }
                    })
                });
        } else {
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'partial_save',
                    data: data,
                    step: step,
                    id: id,
                    nonce: nonce_value
                },
                success: function(response) {
                    if(response) {
                        $('#entry_id').val(response);
                    }
                }
            })
        }
    };

    $('#email_address, #not_insured_email, #second_insured_email_address').blur(function() {
        neverBounceValidate($(this));
    });

    let createEmailErrorNode = () => {
        let een = document.createElement('span');
        een.innerHTML = 'Please enter a valid email.';
        een.classList.add('error');
        een.setAttribute('id', 'email-error-node');
        een.style.color = '#c2272d';
        een.style.fontSize = '12px';
        een.style.display = 'block';
        een.style.paddingTop = '4px';
        return een;
    };

    let neverBounceValidate = (email) => {
        let email_value = email.val();
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'neverbounce_verify',
                email: email_value
            },
            success: function(response) {
                if(response) {
                    let neverbounce_response = JSON.parse(response);
                    $('#never_bounce').val(neverbounce_response);
                    if (neverbounce_response.result == 1) {
                        if(!document.getElementById('email-error-node')) {
                            $('#email-error').remove();
                            let een = createEmailErrorNode();
                            email.removeClass('valid').addClass('error').after(een);
                        }
                    } else {
                        if(document.getElementById('email-error-node')) {
                            email.removeClass('error');
                            $('#email-error-node').remove();
                        }
                    }
                }
            },
            error: function(e) {
                if(!document.getElementById('email-error-node')) {
                    $('#email-error').remove();
                    let een = createEmailErrorNode();
                    email.addClass('error').after(een);
                }
            }
        })
    }

    $('#customRange1-i-dont-know').click(function() {
        $('#customRange1').val('0');
    });
    $('#customRange1-stage-1').click(function() {
        $('#customRange1').val('1');
    });
    $('#customRange1-stage-2').click(function() {
        $('#customRange1').val('2');
    });
    $('#customRange1-stage-3').click(function() {
        $('#customRange1').val('3');
    });
    $('#customRange1-stage-4').click(function() {
        $('#customRange1').val('4');
    });

    $('#customRange2-i-dont-know').click(function() {
        $('#customRange2').val('0');
    });
    $('#customRange2-stage-1').click(function() {
        $('#customRange2').val('1');
    });
    $('#customRange2-stage-2').click(function() {
        $('#customRange2').val('2');
    });
    $('#customRange2-stage-3').click(function() {
        $('#customRange2').val('3');
    });
    $('#customRange2-stage-4').click(function() {
        $('#customRange2').val('4');
    });

    $('#birth_month, #birth_day, #birth_year, #age, #not_insured_birth_month, #not_insured_birth_day, #not_insured_birth_year, #not_insured_age, #second_insured_birth_month, #second_insured_birth_day, #second_insured_birth_year, #second_insured_age').keyup(function() {
        $(this).val($(this).val().replace(/-/gi, ''));
    });

    $('#birth_month').keyup(function() {
        if($(this).val().match(/^\d{2}$/)) {
            $('#birth_day').focus();
        }
    });

    $('#birth_day').keyup(function() {
        if($(this).val().match(/^\d{2}$/)) {
            $('#birth_year').focus();
        }
    });

    //Google reCaptcha
    if(document.getElementById('google_recaptcha')) {
        if(!Cookies.get('g_token_score')) {
            grecaptcha.enterprise.ready(async () => {
                const token = await grecaptcha.enterprise.execute('6Lfr1YsoAAAAAMUHguUu1AsB6QJL03__yUtlE-vV', {action: 'ENTER_FORM'});
                jQuery.ajax({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        data: {
                        action: 'google_recaptcha',
                        token: token
                    },
                    success: function (response) {
                        if (response) {
                            let objResponse = JSON.parse(response);
                            if (objResponse.riskAnalysis) {
                                document.getElementById('google_recaptcha').value = objResponse.riskAnalysis.score;
                                Cookies.set('g_token_score', objResponse.riskAnalysis.score, {expires:1});
                                if(objResponse.riskAnalysis.reasons.length != 0) {
                                    if(objResponse.riskAnalysis.extendedVerdictReasons.length != 0) {
                                        document.getElementById('google_reasons').value = objResponse.riskAnalysis.reasons + ', ' + objResponse.riskAnalysis.extendedVerdictReasons;
                                    } else {
                                        document.getElementById('google_reasons').value = objResponse.riskAnalysis.reasons;
                                    }
                                }
                            }
                        }
                    },
                    error: function (e) {
                        console.error('There was a problem connecting to google');
                    }
                });
            });
        } else {
            document.getElementById('google_recaptcha').value = Cookies.get('g_token_score');
        }
    }

    let getSessionData = () => {
        let iJm15Tr85 = Cookies.get('iJm15Tr85');
        $.ajax({
            type: 'GET',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'ajax_session',
                iJm15Tr85: iJm15Tr85
            },
            success: function(response) {
                if(response) {
                    let objResponse = JSON.parse(response);
                    if(objResponse.entry_id) $('#entry_id').val(objResponse.entry_id);
                    if(objResponse.first_name) $('#first_name').val(objResponse.first_name);
                    if(objResponse.last_name) $('#last_name').val(objResponse.last_name);
                    if(objResponse.phone_number) $('#phone_number').val(objResponse.phone_number);
                    if(objResponse.email_address) $('#email_address').val(objResponse.email_address);
                    if(objResponse.insured_radio) {
                        if(objResponse.insured_radio == 'Yes') {
                            $('#insured_true').attr( 'checked', true );
                        } else {
                            $('#insured_false').attr( 'checked', true );
                        }
                    }
                    if(objResponse.terms) $('#flexCheckIndeterminate').attr( 'checked', true );
                    if(objResponse.sms_consent) $('#sms_consent').attr( 'checked', true );
                    if(objResponse.unique_identifier) $('#unique_identifier').val(objResponse.unique_identifier);
                    if(objResponse.google_click_id) $('#google_click_id').val(objResponse.google_click_id);
                    if(objResponse.facebook_click_id) $('#facebook_click_id').val(objResponse.facebook_click_id);
                    if(objResponse.microsoft_click_id) $('#microsoft_click_id').val(objResponse.microsoft_click_id);
                    if(objResponse.benefits) $('#benefits').val(objResponse.benefits);
                    if(objResponse.policy_type) $('#policy_type').val(objResponse.policy_type);
                    if(objResponse.policy_time) $('#policy_time').val(objResponse.policy_time);
                    if(objResponse.former_employer1) {
                        if(objResponse.former_employer1 == 'Yes') {
                            $('#former_employer1').attr( 'checked', true );
                        } else {
                            $('#former_employer2').attr( 'checked', true );
                        }

                    }
                    if(objResponse.benefits2) {
                        $('#additional-policy').css('display', 'block');
                        $('#benefits2').val(objResponse.benefits2);
                    }
                    if(objResponse.policy_type2) $('#policy_type2').val(objResponse.policy_type2);
                    if(objResponse.policy_time2) $('#policy_time2').val(objResponse.policy_time2);
                    if(objResponse.former_employer3) {
                        if(objResponse.former_employer3 == 'Yes') {
                            $('#former_employer3').attr( 'checked', true );
                        } else {
                            $('#former_employer4').attr( 'checked', true );
                        }
                    }
                    if(objResponse.age) {
                        $('#switch_to_age').attr('checked', true );
                        $('#birthdate_container').css('display', 'none');
                        $('#age_container').css('display', 'block');
                        $('#age').val(objResponse.age);
                    }
                    if(objResponse.birth_day) $('#birth_day').val(objResponse.birth_day);
                    if(objResponse.birth_month) $('#birth_month').val(objResponse.birth_month);
                    if(objResponse.birth_year) $('#birth_year').val(objResponse.birth_year);
                    if(objResponse.gender) {
                        if(objResponse.gender == 'Male') {
                            $('#gender1').attr( 'checked', true );
                        } else {
                            $('#gender2').attr( 'checked', true );
                        }
                    }
                    if(objResponse.current_health) {
                        switch (objResponse.current_health) {
                            case 'Excellent':
                                $('#currentHealth1').attr( 'checked', true );
                                break;
                            case 'Good':
                                $('#currentHealth2').attr( 'checked', true );
                                break;
                            case 'Fair':
                                $('#currentHealth3').attr( 'checked', true );
                                break;
                            case 'Poor':
                                $('#currentHealth4').attr( 'checked', true );
                                break;
                            case 'Terminal':
                                $('#currentHealth5').attr( 'checked', true );
                        }
                    }
                    if(objResponse.not_insured_relationship) $('#not_insured_relationship').val(objResponse.not_insured_relationship);
                    if(objResponse.not_insured_first_name) $('#not_insured_first_name').val(objResponse.not_insured_first_name);
                    if(objResponse.not_insured_last_name) $('#not_insured_last_name').val(objResponse.not_insured_last_name);
                    if(objResponse.not_insured_phone) $('#not_insured_phone').val(objResponse.not_insured_phone);
                    if(objResponse.not_insured_email) $('#not_insured_email').val(objResponse.not_insured_email);
                    if(objResponse.not_insured_age) {
                        $('#not_insured_switch_to_age').attr('checked', true );
                        $('#not_insured_birthdate_container').css('display', 'none');
                        $('#not_insured_age_container').css('display', 'block');
                        $('#not_insured_age').val(objResponse.not_insured_age);
                    }
                    if(objResponse.not_insured_birth_day) $('#not_insured_birth_day').val(objResponse.not_insured_birth_day);
                    if(objResponse.not_insured_birth_month) $('#not_insured_birth_month').val(objResponse.not_insured_birth_month);
                    if(objResponse.not_insured_birth_year) $('#not_insured_birth_year').val(objResponse.not_insured_birth_year);
                    if(objResponse.not_insured_gender) {
                        if(objResponse.not_insured_gender == 'Male') {
                            $('#not-insured-gender1').attr( 'checked', true );
                        } else {
                            $('#not-insured-gender2').attr( 'checked', true );
                        }
                    }
                    if(objResponse.not_insured_current_health) {
                        switch (objResponse.not_insured_current_health) {
                            case 'Excellent':
                                $('#not-insured-currentHealth1').attr('checked', true);
                                break;
                            case 'Good':
                                $('#not-insured-currentHealth2').attr('checked', true);
                                break;
                            case 'Fair':
                                $('#not-insured-currentHealth3').attr('checked', true);
                                break;
                            case 'Poor':
                                $('#not-insured-currentHealth4').attr('checked', true);
                                break;
                            case 'Terminal':
                                $('#not-insured-currentHealth5').attr('checked', true);
                        }
                    }
                    if(objResponse.second_insured_deceased) {
                        if(objResponse.former_employer3 == 'Yes') {
                            $('#deceased1').attr( 'checked', true );
                        } else {
                            $('#deceased2').attr( 'checked', true );
                            $('#second-insured-name, #second-insured-contact, #second-insured-birthdate, #second-insured-sex, #second-insured-current-health').css('display', 'none');
                        }
                        $('#additional-insured').css('display', 'block');
                    }
                    if(objResponse.second_insured_first_name) $('#second_insured_first_name').val(objResponse.second_insured_first_name);
                    if(objResponse.second_insured_last_name) $('#second_insured_last_name').val(objResponse.second_insured_last_name);
                    if(objResponse.second_insured_phone_number) $('#second_insured_phone_number').val(objResponse.second_insured_phone_number);
                    if(objResponse.second_insured_email_address) $('#second_insured_email_address').val(objResponse.second_insured_email_address);
                    if(objResponse.second_insured_age) {
                        $('#second_insured_switch_to_age').attr('checked', true );
                        $('#second_insured_birthdate_container').css('display', 'none');
                        $('#second_insured_age_container').css('display', 'block');
                        $('#second_insured_age').val(objResponse.age);
                    }
                    if(objResponse.second_insured_birth_day) $('#second_insured_birth_day').val(objResponse.second_insured_birth_day);
                    if(objResponse.second_insured_birth_month) $('#second_insured_birth_month').val(objResponse.second_insured_birth_month);
                    if(objResponse.second_insured_birth_year) $('#second_insured_birth_year').val(objResponse.second_insured_birth_year);
                    if(objResponse.second_insured_gender) {
                        if(objResponse.second_insured_gender == 'Male') {
                            $('#second_insured_gender').attr( 'checked', true );
                        } else {
                            $('#second_insured_gender2').attr( 'checked', true );
                        }
                    }
                    if(objResponse.second_insured_health) {
                        switch (objResponse.second_insured_health) {
                            case 'Excellent':
                                $('#otherHealth1').attr('checked', true);
                                break;
                            case 'Good':
                                $('#otherHealth2').attr('checked', true);
                                break;
                            case 'Fair':
                                $('#otherHealth3').attr('checked', true);
                                break;
                            case 'Poor':
                                $('#otherHealth4').attr('checked', true);
                                break;
                            case 'Terminal':
                                $('#otherHealth5').attr('checked', true);
                        }
                    }
                    if(objResponse.second_insured_relationship) $('#relationship').val(objResponse.second_insured_relationship);
                }
            }
        })
    }
    setTimeout(() => {
        getSessionData();
    }, 1000);

    /* Slider Home */
    $('.slider').slick({
        arrows: false,
        dots: true
    });
});

